import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTABand = ({ onApply, title = "Ready to start your aviation career?", text = "Book a discovery flight or apply for training today — our admissions team will be in touch within one business day." }) => (
  <section className="bg-navy-2 relative overflow-hidden" data-testid="cta-band">
    <div className="absolute inset-0 grain" />
    <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-[var(--secondary)] opacity-20 blur-[120px]" />
    <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28 relative">
      <Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="font-display font-light text-4xl md:text-5xl text-white tracking-tight leading-[1.05]">{title}</h2>
            <p className="mt-5 text-white/60 text-lg">{text}</p>
          </div>
          <button onClick={onApply} data-testid="cta-band-apply" className="btn-primary px-8 py-4 inline-flex items-center gap-2 shrink-0">Apply Now <ArrowRight size={18} /></button>
        </div>
      </Reveal>
    </div>
  </section>
);
